import { createAction } from 'redux-actions';

import { CLEAR_LOGS } from '../types';

export const clearLogs = createAction(CLEAR_LOGS);


// WEBPACK FOOTER //
// ./src/features/log/actions/clearLogsActions.js